export enum FileUploadTypeEnum {
    CandidateResume = "CandidateResume",
    CandidatePhoto = "CandidatePhoto",
    InterviewerResume = "InterviewerResume",
    InterviewerPhoto = "InterviewerPhoto",
    CompanyLogo = "CompanyLogo"
}